import React, { Component } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { NotifierConfirm } from '@paragon/notification-tools';

import { resetAnnotationsForActiveDocument } from '../../actions/annotationTools';

type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = DispatchProps;

interface State {
  readonly resetDocumentOpen: boolean;
}

class ResetDocumentButton extends Component<Props, State> {
  state: State = {
    resetDocumentOpen: false,
  };

  onResetDocument = () => {
    this.setState({ resetDocumentOpen: true });
  };

  onConfirmReset = () => {
    this.props.resetAnnotationsForActiveDocument();
    this.closeResetDocument();
  };

  closeResetDocument = () => {
    this.setState({ resetDocumentOpen: false });
  };

  render() {
    return (
      <>
        <Tooltip disableInteractive disableFocusListener id="reset-page-tooltip" title="Reset Document">
          <div>
            <IconButton
              sx={{ borderRadius: 0, width: '100%' }}
              aria-label="Reset Document"
              onClick={this.onResetDocument}
            >
              <RefreshIcon sx={{ transform: 'scaleX(-1)' }} />
            </IconButton>
          </div>
        </Tooltip>
        <NotifierConfirm
          open={this.state.resetDocumentOpen}
          onClose={this.closeResetDocument}
          onClick={this.onConfirmReset}
          message="Are you sure you want to reset your annotations for this document?"
          buttonText="Reset"
        />
      </>
    );
  }
}

const actionCreators = {
  resetAnnotationsForActiveDocument,
};

export default connect(null, actionCreators)(ResetDocumentButton);
